module.exports = __webpack_public_path__ + "img/gift.f1260232.svg";